import classnames from "classnames";
import React from "react";

type ItemProps = {
    item: {
        subCategories: any;
        url: string;
        title: string;
    };
    root?: boolean;
    level?: number;
    onClick: (active: boolean, item: Object) => void;
};

const MOBILE_MAX_MENU_LEVEL = 2;
const SubmenuItem = ({ item, root, level = 0, onClick }: ItemProps) => {
    const showSubMenu =
        item.subCategories.length > 0 && level <= MOBILE_MAX_MENU_LEVEL;

    return (
        <div
            onClick={() => {
                if (showSubMenu) {
                    onClick(showSubMenu, item);
                }
            }}
            className={classnames(
                !root && "sidebar__link",
                root ? "sidebar__assortiment__item" : "sidebar__item",
                root
                    ? "sidebar__assortiment__item--underlined"
                    : "sidebar__item--underlined",
            )}
        >
            <a href={showSubMenu ? "#" : item.url}>{item.title}</a>
            {showSubMenu ? (
                <i className="las la-angle-right text-info" />
            ) : null}
        </div>
    );
};

export { SubmenuItem };
